module.exports = __webpack_public_path__ + "static/media/gami.0ed6f0de.jpg";